var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.menuOption),function(option,index){return [(option.type === 'divider')?_c('div',{key:`divider${index}`,staticClass:"divider"}):_c('EditorBarButton',_vm._b({key:index,attrs:{"editor":_vm.editor}},'EditorBarButton',option,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }